import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { RoleInstitutionControllerService } from "../../../../../../services/role-controller/role-institution-controller.service";
import { Store } from "../../../../../../services/store.service";
import { BaseError } from "../../../../base-error";
import { TranslatedBaseError } from "../../../../TranslatedBaseError";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "determinant-role-institution",
  templateUrl: "./determinant-role-institution.component.html",
  styleUrls: ["./determinant-role-institution.component.scss"],
})
export class DeterminantRoleInstitutionComponent extends TranslatedBaseError {
  public listToggle: boolean = false;
  @Input() public serviceId: string;
  @Input() public roleInstitution;
  @Output() public editCancel = new EventEmitter();

  constructor(private roleInstitutionControllerService: RoleInstitutionControllerService,
              private route: ActivatedRoute,
              public store: Store,
              toastr: ToastrService, public translateService: TranslateService) {
    super(toastr, translateService);
  }

  public updateRoleInstitution() {
    this.roleInstitutionControllerService.saveRoleInstitution(this.roleInstitution.id, this.roleInstitution).subscribe(
      (data) => {
        this.responseSuccessful("Saved successfully!");
        this.closeLayer();
      },
      (error) => {
        this.reloadRole();
        this.showErrorMessage(error);
      },
    );
  }

  public change(event) {
    this.roleInstitution.jsonDeterminants = event.jsonString;
  }

  private reloadRole() {
    this.roleInstitutionControllerService.getRoleInstitutions(this.roleInstitution.id).subscribe(
      (data) => {
        this.roleInstitution = data;
      },
      (error) => {
        this.showErrorMessage(error);
      },
    );
  }

  public closeEdit() {
    this.store.state.common.determinantSection.topLayer = "list";
    this.store.state.common.determinantSection.determinant = {};
  }

  public closeLayer() {
    this.editCancel.emit({cancel: true});
  }

  public setListView(b) {
    this.listToggle = b;
  }

}
